"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryFormatEnum = void 0;
var CountryFormatEnum;
(function (CountryFormatEnum) {
    CountryFormatEnum["DE"] = "DE";
    CountryFormatEnum["EN_US"] = "EN_US";
})(CountryFormatEnum || (exports.CountryFormatEnum = CountryFormatEnum = {}));
